import { Injectable } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { Observable } from "rxjs";
import { ParentGuardianDialogOptions } from "./parentguardian-dialog";
import { ParentGuardianDialogComponent } from "./parentguardian-dialog.component";
import { IParentGuardian } from "app/core/services/mainapp/multiplePathways";


@Injectable()
export class ParentGuardianDialogService {

    constructor(private matDialog: MatDialog) { }

    // #region Close All Dialogs Service Call

    CloseAllDialogs(): void {
        this.matDialog.closeAll();
    }

    // #endregion

    // #region Open Message Box Dialog Service Call

    Open(options?: ParentGuardianDialogOptions): Observable<IParentGuardian> {
        const self = this;

        const openHandle = self.matDialog.open<ParentGuardianDialogComponent>(ParentGuardianDialogComponent, {
            data: {
                TitleText: 'Information',
                MessageText: '',
                OKText: 'OK',
                ...options,
            },
            // width: self.smallMediaSize ? '80vw' : options?.width || '600px',
            // height: self.smallMediaSize ? '80vh' : options?.height || '400px',
            width: '600px',
            height: '400px',
            maxHeight: '85vh',
        });

        return openHandle.afterClosed();
    }

    // #endregion
}